/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type SuggestedAutopilotSettingsV3MovementType = "Day" | "Week" | "%future added value";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type AutopilotFlexibility_event = {
    readonly eventParentRelayId: string;
    readonly attendeePeople: {
        readonly __typename: "PersonList";
        readonly list: ReadonlyArray<{
            readonly id: string;
            readonly emails: ReadonlyArray<string>;
            readonly primaryEmail: string;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly externalImageUrl: string | null;
            } | null;
            readonly isYou: boolean;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly eventKey: {
        readonly id: string;
        readonly externalEventId: string;
    };
    readonly annotatedEvent: {
        readonly orgTags: ReadonlyArray<{
            readonly tag: string;
            readonly state: {
                readonly active: boolean;
                readonly value: string | null;
                readonly subjectType: SubjectUrnTypeEnum;
                readonly subjectValue: string;
                readonly lastModified: number;
            };
        }> | null;
    } | null;
    readonly annotatedRecurringEvent: {
        readonly orgTags: ReadonlyArray<{
            readonly tag: string;
            readonly state: {
                readonly active: boolean;
                readonly value: string | null;
                readonly subjectType: SubjectUrnTypeEnum;
                readonly subjectValue: string;
                readonly lastModified: number;
            };
        }> | null;
    } | null;
    readonly suggestedAutopilotSettingsResponseV3: {
        readonly __typename: "SuggestedAutopilotSettingsResponseV3";
        readonly intersectionOfAttendeesMeetingHours: {
            readonly minSlot: {
                readonly dayOffset: number;
                readonly timeSlot: TimeSlot;
            };
            readonly maxSlot: {
                readonly dayOffset: number;
                readonly timeSlot: TimeSlot;
            };
        } | null;
        readonly calendarIdToMeetingHours: ReadonlyArray<{
            readonly calendarId: string;
            readonly dayOffsetTimeSlotRanges: ReadonlyArray<{
                readonly minSlot: {
                    readonly dayOffset: number;
                    readonly timeSlot: TimeSlot;
                };
                readonly maxSlot: {
                    readonly dayOffset: number;
                    readonly timeSlot: TimeSlot;
                };
            }>;
        }>;
        readonly suggestedAutopilotSettings: {
            readonly isRoomFlexible: boolean;
            readonly movementType: SuggestedAutopilotSettingsV3MovementType;
            readonly allowedEndTime: {
                readonly dayOffset: number;
                readonly timeSlot: TimeSlot;
            } | null;
            readonly allowedStartTime: {
                readonly dayOffset: number;
                readonly timeSlot: TimeSlot;
            } | null;
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly moveRangeInLocalTimeV3: {
        readonly __typename: "MoveRangeInLocalTimeV3";
        readonly allowedStartTimeInclusive: {
            readonly dayOffset: number;
            readonly timeSlot: TimeSlot;
        } | null;
        readonly allowedEndTimeInclusive: {
            readonly dayOffset: number;
            readonly timeSlot: TimeSlot;
        } | null;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "AutopilotFlexibility_event";
};
export type AutopilotFlexibility_event$data = AutopilotFlexibility_event;
export type AutopilotFlexibility_event$key = {
    readonly " $data"?: AutopilotFlexibility_event$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotFlexibility_event">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgTag",
            "kind": "LinkedField",
            "name": "orgTags",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tag",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TagState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subjectType",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subjectValue",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastModified",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ], v3 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOffset",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSlot",
            "storageKey": null
        } as any
    ], v4 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "minSlot",
            "plural": false,
            "selections": (v3 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "maxSlot",
            "plural": false,
            "selections": (v3 /*: any*/),
            "storageKey": null
        } as any
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "AutopilotFlexibility_event",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventParentRelayId",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "attendeePeople",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Person",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v1 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emails",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "primaryEmail",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UserProfile",
                                        "kind": "LinkedField",
                                        "name": "profile",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "givenName",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "familyName",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "externalImageUrl",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isYou",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "PersonList",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventKey",
                "kind": "LinkedField",
                "name": "eventKey",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "externalEventId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AnnotatedEvent",
                "kind": "LinkedField",
                "name": "annotatedEvent",
                "plural": false,
                "selections": (v2 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AnnotatedEvent",
                "kind": "LinkedField",
                "name": "annotatedRecurringEvent",
                "plural": false,
                "selections": (v2 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "suggestedAutopilotSettingsResponseV3",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlotRange",
                                "kind": "LinkedField",
                                "name": "intersectionOfAttendeesMeetingHours",
                                "plural": false,
                                "selections": (v4 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours",
                                "kind": "LinkedField",
                                "name": "calendarIdToMeetingHours",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "calendarId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DayOffsetTimeSlotRange",
                                        "kind": "LinkedField",
                                        "name": "dayOffsetTimeSlotRanges",
                                        "plural": true,
                                        "selections": (v4 /*: any*/),
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SuggestedAutopilotSettingsV3",
                                "kind": "LinkedField",
                                "name": "suggestedAutopilotSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isRoomFlexible",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "movementType",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DayOffsetTimeSlot",
                                        "kind": "LinkedField",
                                        "name": "allowedEndTime",
                                        "plural": false,
                                        "selections": (v3 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DayOffsetTimeSlot",
                                        "kind": "LinkedField",
                                        "name": "allowedStartTime",
                                        "plural": false,
                                        "selections": (v3 /*: any*/),
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "SuggestedAutopilotSettingsResponseV3",
                        "abstractKey": null
                    },
                    (v5 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "moveRangeInLocalTimeV3",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlot",
                                "kind": "LinkedField",
                                "name": "allowedStartTimeInclusive",
                                "plural": false,
                                "selections": (v3 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlot",
                                "kind": "LinkedField",
                                "name": "allowedEndTimeInclusive",
                                "plural": false,
                                "selections": (v3 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "type": "MoveRangeInLocalTimeV3",
                        "abstractKey": null
                    },
                    (v5 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "type": "Event",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'b0549bad0084b79b16311ad193769cb2';
export default node;
